import { Form, message, Switch } from "antd";
import { useEffect, useState } from "react";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { toggleFolderActive } from "../../redux/actions/folderActions.tsx";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  folder: Folder;
}

type FormValues = {
  is_active: boolean;
};

export const ToggleStatus: React.FC<Props> = ({ folder }) => {
  const [statusForm] = Form.useForm();
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [isActive, setIsActive] = useState(folder.is_active);

  const { loadingStatus } = useAppSelector((state) => state.folder);

  useEffect(() => {
    handleInitForm();
    setIsActive(folder.is_active);
  }, [folder]);

  const handleInitForm = () => {
    statusForm.setFieldsValue({
      is_active: folder.is_active,
    });
  };

  const handleSwitchChange = async (checked: boolean) => {
    try {
      await dispatch(
        toggleFolderActive({
          id: folder.id,
          is_active: checked,
        }),
      ).unwrap();

      setIsActive(checked);
      messageApi.open({
        type: "success",
        content: "Estatus actualizado.",
      });
    } catch (error: any) {
      statusForm.setFieldsValue({
        is_active: isActive,
      });
      messageApi.error(extractErrorMessage(error, "No se pudo actualizar el estado del expediente."));
    }
  };

  return (
    <Form form={statusForm} initialValues={{ is_active: isActive }}>
      {contextHolder}
      {/* `noStyle`: el Form.Item trae 24px de margen inferior que subían el switch
          respecto al resto de la fila de acciones de la tarjeta. */}
      <Form.Item<FormValues> name="is_active" noStyle>
        <Switch
          checkedChildren="Activo"
          unCheckedChildren="Inactivo"
          onChange={handleSwitchChange}
          loading={loadingStatus}
          checked={isActive}
        />
      </Form.Item>
    </Form>
  );
};
